module.exports = __webpack_public_path__ + "img/app-menu-icon.4c7d08dc.svg";